import { Form } from 'react-bootstrap';
import { CustomTooltip } from '../CustomTooltip';
import './style.css';

interface SwitchProps {
  styleContainer?: React.CSSProperties;
  index?: number;
  isActive: boolean;
  activeLabel: string;
  notActiveLabel: string;
  handleActiveChange: (checked: boolean, index?: number) => void;
  infoImageSrc?: string;
  infoImageAlt?: string;
  infoImageStyle?: React.CSSProperties;
  infoImageTooltipId?: string;
  infoImageTooltipText?: string;
}

export default function Switch({
  styleContainer,
  index,
  isActive,
  activeLabel,
  notActiveLabel,
  handleActiveChange,
  infoImageSrc,
  infoImageAlt,
  infoImageStyle,
  infoImageTooltipId,
  infoImageTooltipText,
}: SwitchProps) {
  return (
    <div className="switch-container" style={styleContainer}>
      <Form.Check
        type="switch"
        id={`isActive-switch-${index ?? ''}`}
        label={isActive ? activeLabel : notActiveLabel}
        checked={isActive}
        onChange={(e) => handleActiveChange(e.target.checked, index)}
      />
      {infoImageSrc && infoImageTooltipId ? (
        <>
          <img src={infoImageSrc} alt={infoImageAlt} style={infoImageStyle} data-tooltip-id={infoImageTooltipId} />
          <CustomTooltip id={infoImageTooltipId}>{infoImageTooltipText}</CustomTooltip>
        </>
      ) : null}
    </div>
  );
}
